// Shared by NavTabs and the media page tab bar so both bars stay identical

// Sticky line bar on the page background; `data-stuck` is set by useStuckAttribute.
// The transparent top border is the pixel hidden by `-top-px` once stuck, so the content stays centred
export const NAV_TABS_BAR_CLASSES =
  "bg-background sticky -top-px z-20 border-y border-t-transparent transition-shadow data-stuck:shadow-md";

export const NAV_TABS_LIST_CLASSES = "h-12! gap-6 p-0";

// Triggers fill the bar height so the underline sits over its bottom border; grey on hover, primary when active
export const NAV_TABS_TRIGGER_CLASSES =
  "data-[state=active]:text-primary dark:data-[state=active]:text-primary after:bg-muted-foreground data-[state=active]:after:bg-primary h-full px-3 group-data-[orientation=horizontal]/tabs:after:-bottom-px hover:after:opacity-100";
